import { Component, TemplateRef, ViewChild, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthorizationTypeSelectionComponent } from '@app/components/authorization-type-selection/authorization-type-selection.component';
import { AuthorizationModalService } from '@app/services/shared/authorization-modal.service';

@Component({
  selector: 'app-authorization-type-modal',
  standalone: true,
  templateUrl: './authorization-type-modal.component.html',
  styleUrls: ['./authorization-type-modal.component.scss'],
  imports: [CommonModule, AuthorizationTypeSelectionComponent]
})
export class AuthorizationTypeModalComponent implements OnInit {

  @ViewChild('authorizationModalTemplate') modalTemplate!: TemplateRef<any>;

  authorizationType: string = '';
  isOpen: boolean = false;

  constructor(private authorizationModalService: AuthorizationModalService) { }

  ngOnInit(): void {
    this.subscribeToModalState();
  }

  subscribeToModalState(): void {
    this.authorizationModalService.modalState$.subscribe(state => {
      this.authorizationType = state.authorizationType || '';
      this.isOpen = state.isOpen;

      if (this.isOpen && this.modalTemplate) {
        this.authorizationModalService.openAuthorizationModal(this.modalTemplate, this.authorizationType);
      }
    });
  }
}
